import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import AgenceSettingsDatatableHandler from '../containers/datatableHandlers/AgenceSettingsDatatableHandler copy/AgenceSettingsDatatableHandler';
import AgenceAddressFormHandle from '../containers/formHandlers/agence/AgenceAddressFormHandler/AgenceAddressFormHandle';
import AgenceFormHandle from '../containers/formHandlers/agence/AgenceFormHandler/AgenceFormHandle';

const tabHeaders = ['Agence', 'Adresse', 'Paramètres'];
const tabContents = [
  <AgenceFormHandle />,
  <AgenceAddressFormHandle />,
  <AgenceSettingsDatatableHandler />,
];

export default function Agence() {
  return (
    <>
      <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  );
}
